module.exports = __webpack_public_path__ + "Roboto-RegularItalic.df8e3a9b9aed94341797.woff2";


//////////////////
// WEBPACK FOOTER
// ./~/roboto-fontface/fonts/Roboto/Roboto-RegularItalic.woff2
// module id = 251
// module chunks = 2